import { TIMECLOCK_GEOFENCING_MODES } from '../constants';

export const NOTIFICATIONS_NOTIFY_MODES = [
  { value: 0, label: 'Never' },
  { value: 1, label: 'Always when there is a new notification on my Dashboard' },
];

export const MESSAGES_NOTIFY_MODES = [
  { value: 0, label: 'Never' },
  { value: 1, label: 'Always when I receive a new message' },
  { value: 2, label: 'Only when I am mentioned or get a direct message' },
];

export const NEWSFEED_NOTIFY_MODES = [
  { value: 0, label: 'Never' },
  { value: 1, label: 'Always when there is a new post to pages I follow' },
  { value: 2, label: 'Only when I am mentioned' },
];

export const TIME_FORMATS = [
  { value: false, label: '13:40' },
  { value: true, label: '1:40 PM' },
];

export const NAME_FORMATS = [
  { value: false, label: 'John Appleseed' },
  { value: true, label: 'Appleseed, John' },
];

export const SHIFT_ALARM_OPTIONS_IN_MINUTES = [
  { value: 5, label: '5 minutes' },
  { value: 10, label: '10 minutes' },
  { value: 15, label: '15 minutes' },
  { value: 20, label: '20 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 45, label: '45 minutes' },
  { value: 60, label: '60 minutes' },
  { value: 120, label: '120 minutes' },
  { value: 180, label: '180 minutes' },
];

export const SHIFT_ALARM_OPTIONS_IN_HOURS = [
  { value: 1 },
  { value: 2 },
  { value: 3 },
  { value: 6 },
  { value: 9 },
  { value: 12 },
  { value: 18 },
  { value: 24 },
];

export const SHIFT_ALARMS_UNIT_OPTIONS = [
  { value: 'minutes', label: 'Minutes' },
  { value: 'hours', label: 'Hours' },
];

export const BREAK_OPTIONS = [
  { value: 1, label: 'Unpaid' },
  { value: 2, label: 'Paid' },
];

export const BREAK_DURATION_OPTIONS = [
  { value: 0, label: 'No break' },
  { value: 10, label: '10 minutes' },
  { value: 15, label: '15 minutes' },
  { value: 20, label: '20 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 45, label: '45 minutes' },
  { value: 60, label: '60 minutes' },
];

export const CONVERSATION_TYPE = {
  NONE: 'NONE',
  PRIVATE_ONLY: 'PRIVATE_ONLY',
  ALL: 'ALL',
};

export const CONVERSATION_OPTIONS = [
  { label: 'Group and private conversations', value: CONVERSATION_TYPE.ALL },
  { label: 'Only private conversations', value: CONVERSATION_TYPE.PRIVATE_ONLY },
];

export const SINGLE_LOCATION_OTHER_SCHEDULES_OPTIONS = [
  { label: 'Employees can view full schedule for all positions', positions: true },
  { label: 'Employees can view schedule for their position', positions: false },
];

export const MULTI_LOCATION_OTHER_SCHEDULES_OPTIONS = [
  { label: 'Employees can view full schedule in all locations', locations: true, positions: true },
  {
    label: 'Employees can view full schedule within their own location',
    locations: false,
    positions: true,
  },
  {
    label: 'Employees can view schedule for their position in all locations',
    locations: true,
    positions: false,
  },
  {
    label: 'Employees can view schedule for their position within their own location',
    locations: false,
    positions: false,
  },
];

export const LEAVE_REQUEST_BEFORE_DAYS_OPTIONS = [
  { label: '1 day', value: 1 },
  { label: '2 days', value: 2 },
  { label: '3 days', value: 3 },
  { label: '4 days', value: 4 },
  { label: '5 days', value: 5 },
  { label: '6 days', value: 6 },
  { label: '7 days', value: 7 },
  { label: '14 days', value: 14 },
  { label: '21 days', value: 21 },
  { label: '28 days', value: 28 },
];

export const CSV_DELIMITERS = [
  { label: ', (comma)', value: ',' },
  { label: '; (semicolon)', value: ';' },
];

export const CLOCK_IN_ROUNDING_OPTIONS = [
  { label: 'No rounding', value: 0 },
  { label: '5 minutes', value: 5 },
  { label: '10 minutes', value: 10 },
  { label: '15 minutes', value: 15 },
];

export const UNIT_SYSTEMS = [
  { label: 'feet', value: true },
  { label: 'meters', value: false },
];

export const CLOCK_IN_NOTIFICATIONS_MINUTES_OPTIONS = [
  { label: '15 minutes', value: 15 },
  { label: '20 minutes', value: 20 },
  { label: '30 minutes', value: 30 },
];

export const CLOCK_IN_NOTIFICATIONS_OPTIONS = [
  { label: 'Always when employees clock in or forget to clock in', value: 3 },
  { label: 'Only when employees clock in late or forget to clock in', value: 2 },
  { label: 'Never', value: 0 },
];

export const CLOCK_OUT_NOTIFICATIONS_OPTIONS = [
  { label: 'Always when employees clock out or forget to clock out', value: 3 },
  { label: 'Only when employees clock out late or forget to clock out', value: 2 },
  { label: 'Never', value: 0 },
];

export const TIME_CLOCK_GEOFENCING_MODES_OPTIONS = [
  { label: 'On clocking in and out', value: TIMECLOCK_GEOFENCING_MODES.BOTH },
  { label: 'Only on clock in', value: TIMECLOCK_GEOFENCING_MODES.ONLY_CLOCK_IN },
  { label: 'Only on clock out', value: TIMECLOCK_GEOFENCING_MODES.ONLY_CLOCK_OUT },
];

export const ANY_PROTOCOL_REGEX = /(^\w+:|^)\/\//;

export const PTO_RESET_DATE_OPTIONS = [
  { value: true, label: 'Common date' },
  { value: false, label: 'Hire date' },
];
